import api, { ValidateAxiosError } from '@/modules/api.service';
import { ConfiguracoesDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';

/**
 * Serviços globais da aplicação.
 */
export class AplicationService {
  /**
   * Ler as configurações do sistema.
   * @returns Configuracoes
   */
  async readConfiguracoes(): Promise<ConfiguracoesDto[]> {
    try {
      const response = await api.get(Endpoints.APP + '/configuracoes');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(
        error,
        'Impossível buscar configurações do sistema!',
      );
    }
  }
}
